<!-- <h1 class="UserManager">User Manager Under Development!</h1> -->
<!-- <div class="PageTop">
  <div class="table">
    <div class="HeaderText">
      <span style="font-size: 30px">EMDM User Manager</span>
    </div>
    <table class="tableWidth">
      <tbody>
        <tr>
          <td style="width: 50%">
            <div id="Item1" class="counter card">
              <div id="ItemData1" class="cardData">
                <div class="cardIcon green" style="text-align: center">
                  <fa-icon [icon]="faCompleted" class="iconInprogress"></fa-icon>
                </div>
                <div class="cardText">
                  <span class="cardCount">{{ statusCount.Completed }}</span><label class="labelName">Active</label>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div id="Item2" class="counter card">
              <div id="ItemData2" class="cardData">
                <div class="red cardIcon" style="text-align: center">
                  <fa-icon [icon]="faError" class="iconInprogress"></fa-icon>
                </div>
                <div class="cardText">
                  <span class="cardCount">{{ statusCount.InError }}</span><label class="labelName">In Active</label>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->
<div class="marginrl30">
  <div class="contentTopNew">
    <div class="title">EMDM User Manager</div>

    <div class="contentRight">
      <div class="statusCardDetails">
        <div class="cardBlock">
          <div class="card">
            <div class="cardData">
              <div class="cardIcon green" style="text-align: center">
                <fa-icon [icon]="faCompleted" class="iconInprogress"></fa-icon>
              </div>
              <div class="cardText">
                <span class="cardCount">{{ statusCount.Completed }}</span
                ><label class="labelName">Active</label>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="cardData">
              <div class="red cardIcon" style="text-align: center">
                <fa-icon [icon]="faError" class="iconInprogress"></fa-icon>
              </div>
              <div class="cardText">
                <span class="cardCount">{{ statusCount.InError }}</span
                ><label class="labelName">In Active</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttonSet">
    <div class="LayerOne">
      <kendo-textbox
        placeholder="[Contains] Name or Username"
        style="width: 20%; margin-right: 10px"
        [(ngModel)]="searchString"
        (keydown.enter)="searchUser()"
      >
      </kendo-textbox>
      <button type="button" class="userSearchBtn" (click)="searchUser()">
        Search
      </button>

      <kendo-dropdownlist
        [data]="dropDownList"
        [(ngModel)]="selectedValue"
        textField="text"
        valueField="value"
        class="dropdownSelect"
        [fillMode]="'flat'"
      >
      </kendo-dropdownlist>

      <button
        kendoButton
        (click)="assignGroups()"
        class="h-34"
        [ngClass]="selectedIds.size > 0 ? 'button-secondary' : 'btn-disabled'"
      >
        Apply Changes
      </button>
    </div>
    <div class="LayerTwo">
      <div class="partOne">
        <button
          type="button"
          class="sortBtn"
          value="Search"
          id="searchBtn"
          style="height: 30px; margin-left: 10px !important"
          (click)="saveConfig(userManagerGrid)"
        >
          <fa-icon [icon]="faSave"></fa-icon> Save Configs
        </button>
        <button
          type="button"
          class="sortBtn"
          value="Search"
          id="searchBtn"
          style="height: 30px"
          (click)="clearConfig(userManagerGrid)"
        >
          Reset Configs
        </button>
        <button
          type="button"
          class="sortBtn"
          value="Search"
          id="searchBtn"
          style="height: 30px"
          (click)="clearSort()"
        >
          <fa-icon [icon]="faSort"></fa-icon> Clear Sort
        </button>
        <button
          type="button"
          class="sortBtn"
          value="Search"
          id="searchBtn"
          style="height: 30px"
          (click)="clearFilter()"
        >
          <fa-icon [icon]="faFilter"></fa-icon> Clear Filters
        </button>
      </div>
      <div class="partTwo">
        <button
          type="button"
          class="exportBtn"
          value="Search"
          id="searchBtn"
          style="height: 30px"
          (click)="exportUserList()"
        >
          Export User List
        </button>
      </div>
    </div>
  </div>
  <div class="gridData" id="styleGrid">
    <ng-template #template let-anchor>
      <span class="toolTip">{{ anchor.nativeElement.innerText }}</span>
    </ng-template>
    <div
      kendoTooltip
      showOn="none"
      [tooltipTemplate]="template"
      filter=".k-grid td,.k-grid td span "
      (mouseover)="showTooltip($event)"
      class="toolTip"
      #tooltipDir="kendoTooltip"
    >
      <kendo-grid
        id="userManagerGrid"
        #userManagerGrid
        [kendoGridBinding]="UserManagerView"
        [pageSize]="15"
        [pageable]="true"
        [skip]="skip"
        (pageChange)="pageChange($event)"
        [sortable]="{ mode: 'single' }"
        [group]="group"
        [groupable]="true"
        [resizable]="true"
        [reorderable]="true"
        filterable="menu"
        [selectable]="{ enabled: true, checkboxOnly: true }"
        kendoGridSelectBy
        [(selectedKeys)]="selectedIndexes"
        (selectionChange)="OnSelectionChangeEvent($event)"
        [height]="500"
        [sort]="sort"
        (sortChange)="OnSortChange($event)"
        [filter]="filter"
        (filterChange)="OnFilterChange($event)"
        (groupChange)="groupChange($event)"
      >
        <!-- (dataStateChange)="sortChange($event)" -->
        <kendo-grid-checkbox-column
          [width]="45"
          class="Checkbox"
          [resizable]="false"
          [showSelectAll]="true"
          field=""
          id="userManagerGrid"
        ></kendo-grid-checkbox-column>
        <kendo-grid-column
          field="name"
          title="Name"
          class="text-align-left"
          [minResizableWidth]="150"
          [width]="150"
        ></kendo-grid-column>
        <kendo-grid-column
          field="username"
          title="Username"
          class="text-align-left"
          [minResizableWidth]="150"
          [width]="150"
        ></kendo-grid-column>
        <kendo-grid-column
          field="userID"
          title="UserID"
          class="text-align-left"
          [minResizableWidth]="150"
          [width]="150"
        ></kendo-grid-column>
        <kendo-grid-column
          field="email"
          title="E-Mail"
          class="text-align-left"
          [minResizableWidth]="150"
          [width]="150"
        ></kendo-grid-column>
        <kendo-grid-column
          field="mobilePhone"
          title="MobilePhone"
          class="text-align-left"
          [minResizableWidth]="150"
          [width]="150"
        ></kendo-grid-column>
        <kendo-grid-column
          field="creationDate"
          title="Creation Date"
          [width]="130"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{
              dataItem.creationDate | date : "dd-MM-yyyy hh:mm a"
            }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="lastLogin" title="Last Login" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.lastLogin | date : "dd-MM-yyyy hh:mm a" }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="isActive" title="Is Active" class="text-align-center" [width]="120">
          <ng-template kendoGridCellTemplate let-dataitem>
            <input
              type="checkbox"
              class="text-align-center"
              kendoCheckBox
              [checked]="dataitem.isActive"
              disabled
            />
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="groups"
          title="User Group(s)"
          class="text-align-left"
          [width]="150"
        >
          <!-- <ng-template kendoGridCellTemplate let-dataitem>
          <span class="datitemGroup">{{ dataitem.groups }}</span>
        </ng-template> -->
        </kendo-grid-column>
        <kendo-grid-column
          field="roles"
          title="Emdm User Role(s)"
          class="text-align-left"
          [width]="150"
        >
          <!-- <ng-template kendoGridCellTemplate let-dataitem>
          <span>{{ dataitem.roles }}</span>
        </ng-template> -->
        </kendo-grid-column>
        <ng-template kendoPagerTemplate>
          <div class="usermanagerpager">
            <div class="pagerNumbers">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons
                [buttonCount]="3"
              ></kendo-pager-numeric-buttons>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
            <div class="pagerInfo">
              <kendo-pager-info></kendo-pager-info>
            </div>
          </div>
        </ng-template>
      </kendo-grid>
    </div>
  </div>
</div>
